import * as requests from '../api-request'
import getToken from '../get-token'
import { createQueryString } from '../api-request'

export const getShotList = async (data = {}) => {
  const queryString = requests.createQueryString(data)
  return requests.toJSON('GET', `shot_list/get_shot_list?${queryString}`, {})
}

export const createNewShotList = async (data) => {
  return requests.toJSON('POST', 'shot_list/create', data)
}

export const getSceneShots = async (data, token) => {
  return requests.toJSON('POST', 'shot_list/get_shot_list_scene_data', data, token)
}

export const getAllScenesShots = async (data) => {
  return requests.toJSON('POST', 'shot_list/get_shot_list_all_scenes_shots_data', data)
}

export const createShot = async (data) => {
  return requests.toJSON('POST', 'shot_list/create_shot_list_scene_data', data)
}

export const updateShot = async (data) => {
  return requests.toJSON('POST', 'shot_list/update_shot_list_scene_data', data)
}

export const regenerateSceneShots = async (data) => {
  return requests.toJSON('POST', 'shot_list/regenerate_scene_shot_data', data)
}

export const regenerateShotList = async (data) => {
  return requests.toJSON('POST', 'shot_list/regenerate_shot_list', data)
}

export const getSceneIds = async (data) => {
  const queryString = requests.createQueryString(data)
  return requests.toJSON('GET', `shot_list/get_scene_ids?${queryString}`, data)
}

export const createExportJob = async (data, token) => {
  token = token || (await getToken())
  return requests.toJSON('POST', 'shot_list/export_pdf', data, token)
}

export const getRunningPdfExport = async (data, token) => {
  token = token || (await getToken())
  const queryString = createQueryString(data)
  return requests.toJSON('GET', `shot_list/running_pdf_export?${queryString}`, token)
}

export const getCompletedPdfs = async (data, token) => {
  token = token || (await getToken())
  const queryString = createQueryString(data)
  return requests.toJSON('GET', `shot_list/completed_pdfs?${queryString}`, token)
}
